module.exports = __webpack_public_path__ + "static/media/Government House c. 1875.d2aa46af.jpg";